<div class="card mb-3">
    <div class="card-body">
        <div class="mb-3">
            <h5 class="mb-0">
                {{ 'titles_usersAccessToSystems' | translate: 'online' : 'userAdministration' }}
            </h5>
        </div>

        <div class="row g-3 mb-4">
            <!-- Available systems -->
            <div class="col-6">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-semibold">
                        {{ 'titles_systems' | translate: 'online' : 'userAdministration' }}
                        ({{ availableSystems().length }})
                    </span>
                    <button
                        type="button"
                        class="btn btn-link btn-sm text-decoration-none p-0"
                        [disabled]="availableSystems().length === 0"
                        (click)="assignAll(availableSystems())">
                        {{ 'actions_assignAll' | translate: 'online' : 'userAdministration' }}
                    </button>
                </div>
                <input
                    class="form-control form-control-sm mb-2"
                    type="text"
                    [placeholder]="
                        'placeholders_searchSystems' | translate: 'online' : 'userAdministration'
                    "
                    (input)="onAvailableSearchChange($event)" />
                <div class="border rounded overflow-auto position-relative" style="height: 350px">
                    @if (buildingsLoading()) {
                        <div class="position-absolute top-50 start-50 translate-middle">
                            <app-load />
                        </div>
                    }
                    <table class="table table-hover table-sm mb-0">
                        <thead class="table-light sticky-top">
                            <tr>
                                <th>
                                    {{
                                        'properties_systemNo'
                                            | translate: 'online' : 'userAdministration'
                                    }}
                                </th>
                                <th>
                                    {{
                                        'properties_buildingName'
                                            | translate: 'online' : 'userAdministration'
                                    }}
                                </th>
                                <th class="pe-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (system of availableSystems(); track system.buildingNo) {
                                <tr>
                                    <td class="align-middle">{{ system.buildingNo }}</td>
                                    <td class="align-middle">{{ system.address }}</td>
                                    <td class="text-end pe-3">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            (click)="assignSystem(system)">
                                            <i class="bi bi-arrow-right"></i>
                                        </button>
                                    </td>
                                </tr>
                            } @empty {
                                @if (!buildingsLoading()) {
                                    <tr>
                                        <td colspan="3" class="text-center text-muted py-4">
                                            {{
                                                'table_noResultsText.accessToAllSystems'
                                                    | translate: 'online' : 'userAdministration'
                                            }}
                                        </td>
                                    </tr>
                                }
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Assigned systems -->
            <div class="col-6">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-semibold">
                        {{ 'titles_accessToSystems' | translate: 'online' : 'userAdministration' }}
                        ({{ assignedSystems().length }})
                    </span>
                    <button
                        type="button"
                        class="btn btn-link btn-sm text-decoration-none p-0 text-danger"
                        [disabled]="assignedSystems().length === 0"
                        (click)="removeAll(assignedSystems())">
                        {{ 'actions_removeAll' | translate: 'online' : 'userAdministration' }}
                    </button>
                </div>
                <input
                    class="form-control form-control-sm mb-2"
                    type="text"
                    [placeholder]="
                        'placeholders_searchSystems' | translate: 'online' : 'userAdministration'
                    "
                    (input)="onAssignedSearchChange($event)" />
                <div class="border rounded overflow-auto position-relative" style="height: 350px">
                    <table class="table table-hover table-sm mb-0">
                        <thead class="table-light sticky-top">
                            <tr>
                                <th>
                                    {{
                                        'properties_systemNo'
                                            | translate: 'online' : 'userAdministration'
                                    }}
                                </th>
                                <th>
                                    {{
                                        'properties_buildingName'
                                            | translate: 'online' : 'userAdministration'
                                    }}
                                </th>
                                <th class="pe-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (system of assignedSystems(); track system.buildingNo) {
                                <tr>
                                    <td class="align-middle">{{ system.buildingNo }}</td>
                                    <td class="align-middle">{{ system.address }}</td>
                                    <td class="text-end pe-3">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            (click)="removeSystem(system)">
                                            <i class="bi bi-arrow-left"></i>
                                        </button>
                                    </td>
                                </tr>
                            } @empty {
                                @if (!buildingsLoading()) {
                                    <tr>
                                        <td colspan="3" class="text-center text-muted py-4">
                                            {{
                                                'table_noResultsText.accessToNoSystems'
                                                    | translate: 'online' : 'userAdministration'
                                            }}
                                        </td>
                                    </tr>
                                }
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
